document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('video[autoplay][muted]');

  videos.forEach((video) => {
    // Assure que Safari ne bloque pas l'autoplay
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.muted = true;
    video.playsInline = true;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch((err) => {
        console.warn('Autoplay bloqué, tentative de relance sur interaction', err);
        // Fallback : relancer à la première interaction utilisateur
        const resume = () => {
          video.play();
          document.removeEventListener('touchstart', resume);
          document.removeEventListener('click', resume);
        };
        document.addEventListener('touchstart', resume);
        document.addEventListener('click', resume);
      });
    }
  });
});
